class ApiClient {
  constructor(baseURL) {
    this.baseURL = baseURL;
  }

  getFullUrl(endpoint) {
    return `${this.baseURL}/${endpoint}`;
  }

  getAuthHeaders() {
    const token = sessionStorage.getItem("authToken");
    return token ? { Authorization: `Bearer ${token}` } : {};
  }

async handleResponse(response) {
  const contentType = response.headers.get("content-type");

  if (response.ok) {
    if (contentType?.includes("application/json")) {
      const text = await response.text();
      let data;
      try {
        data = text.trim() ? JSON.parse(text.trim()) : {};
      } catch {
        data = { message: text.trim() };
      }

      // Trim arrays for PHP response compatibility
      if (data.item_ids) data.item_ids = data.item_ids.map(id => id.trim());
      if (data.descriptions) data.descriptions = data.descriptions.map(desc => desc.trim());
      if (data.total_quantity) data.total_quantity = data.total_quantity.map(q => q.trim());
      if (data.price_per_quantity) data.price_per_quantity = data.price_per_quantity.map(p => p.trim());
      if (data.total_price) data.total_price = data.total_price.map(t => t.trim());
      if (data.image && typeof data.image === 'object') {
        Object.keys(data.image).forEach(key => {
          data.image[key] = data.image[key].trim();
        });
      }

      return data; // now whitespace won’t break JSON
    }

    // Handle other content types
    if (contentType?.includes("application/pdf")) {
      return new Blob([await response.arrayBuffer()], { type: "application/pdf" });
    }
    if (
      contentType?.includes("application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") ||
      contentType?.includes("application/vnd.ms-excel")
    ) {
      return new Blob([await response.arrayBuffer()], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      });
    }

    return await response.text();
  }

  // Error handling
  const text = await response.text();
  let parsed;
  try {
    parsed = text.trim() ? JSON.parse(text.trim()) : {};
  } catch {
    parsed = { message: text.trim() };
  }

  let errorMessage = parsed.message || parsed.Message || `API Error (${response.status})`;
  if (parsed.errors && typeof parsed.errors === "object") {
    const validationMessages = Object.values(parsed.errors).flat().join(", ");
    if (validationMessages) errorMessage += `: ${validationMessages}`;
  }

  const error = new Error(errorMessage);
  error.details = parsed.details || parsed.Errors || parsed.errors;
  error.status = response.status;
  throw error;
}


  async get(endpoint) {
    const response = await fetch(`${this.baseURL}${endpoint}`, {
      method: "GET",
      headers: this.getAuthHeaders(),
    });
    return this.handleResponse(response);
  }

  async post(endpoint, data, isFormData = false) {
    const headers = this.getAuthHeaders();
    if (!isFormData) headers["Content-Type"] = "application/json";

    const response = await fetch(`${this.baseURL}${endpoint}`, {
      method: "POST",
      headers,
      body: isFormData ? data : JSON.stringify(data),
    });

    return this.handleResponse(response);
  }

  async put(endpoint, data, isFormData = false) {
    const headers = this.getAuthHeaders();
    if (!isFormData) headers["Content-Type"] = "application/json";

    const response = await fetch(`${this.baseURL}${endpoint}`, {
      method: "PUT",
      headers,
      body: isFormData ? data : JSON.stringify(data),
    });

    return this.handleResponse(response);
  }

  async delete(endpoint) {
    const response = await fetch(`${this.baseURL}${endpoint}`, {
      method: "DELETE",
      headers: this.getAuthHeaders(),
    });

    return this.handleResponse(response);
  }
}

// export const APIURL = new ApiClient("http://localhost/admin_dashboard/api");
export const APIURL = new ApiClient("https://thechennaicomputersmobile.com/admin_dashboard/api");

// Separate constant for images (no API prefix)

// export const IMAGE_BASE_URL = "http://localhost/admin_dashboard/tccbackend/";
export const IMAGE_BASE_URL = "https://thechennaicomputersmobile.com/admin_dashboard/tccbackend/";

export default APIURL;
